
<!-- breadcrumb -->
<div class="breadcrumb-header justify-content-between upload-header">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto upload-title">Subir análisis área de RX CORPORAL ({{numeroOrden}})</h4><span
    class="text-muted mt-1 tx-13 ms-2 mb-0">/ Ordenes / Inicio</span>
  </div>
</div>
<div class="d-flex my-xl-auto right-content mr-2 upload-actions d-none d-lg-flex">

  <div class="mb-3 mb-xl-0 upload-actions-group">

    <button type="button" class="btn btn-primary upload-btn-primary" (click)="subirImagenes()"><i class="icon ion-ios-filing"></i> GUARDAR</button>
    <button type="button" class="btn btn-light upload-btn-secondary" (click)="volverAtras()">VOLVER</button>

  </div>
</div>
</div>
@if (spinnerBoolean) {
  <div class="text-center">
    <hr>
      <div class="spinner-grow" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <p class="text-center">{{cargando}}</p>
    </div>
  }
  <div class="row row-sm">
    <div class="col-md-12">
      <div class="card order-summary-card">
        <h6 class="card-title text-uppercase p-2  text-white mb-1" style="background-color:#2E3D8C">
          Datos de la orden
        </h6>
        <div class="card-body order-summary-body">



          <div class="mb-2 summary-item">
            <b>PACIENTE</b>
            <p>{{nombrePaciente}}</p>

          </div>
          <div class="mb-2 summary-item">
            <b>DOCTOR</b>
            <p>{{nombreDoctor}}</p>

          </div>

        </div>





      </div>
    </div>


    <div class="col-md-12">
      <div class="card detail-card">
        <h6 class="card-title text-uppercase p-2  text-white mb-1" style="background-color:#2E3D8C">
          Detalle Orden
        </h6>
        <div class="card-body">

          <div class="d-none d-lg-block">
            <table class="table table-striped tablaServicioOrden" width="100%">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Observación</th>

                  <th>Imagenes</th>
                </tr>
              </thead>

              <tbody class="servicios">

                @for (dynamic of detalleOrden; track dynamic; let i = $index) {
                  <tr >
                    @if (detalleOrden[i].tipo == 'RADIOGRAFIAS CORPORAL') {
                      <td> {{i+1}}</td>
                    }
                    @if (detalleOrden[i].tipo == 'RADIOGRAFIAS CORPORAL') {
                      <td style="width:500px;"><b>SERVICIO:</b> {{detalleOrden[i].producto}}<br><textArea type="text" class="form-control textWidth descripcion"  name="nombre"  readonly>{{detalleOrden[i].pieza}}</textArea></td>
                    }
                    @if (detalleOrden[i].tipo == 'RADIOGRAFIAS CORPORAL'  && detalleOrden[i].valor != '0') {
                      <td style="width:1100px;">
                        <hr>
                          <div class="form-row">
                            @for (f of detalleOrden[i].imagenesSubidas; track f; let j = $index) {
                              <div class="col-md-6"><img  [src]="f.imagen"> </div>
                            }
                          </div>
                        </td>
                      }
                    </tr>
                  }





                </tbody>


              </table>
            </div>

            <div class="d-lg-none mobile-study-list">
              @for (dynamic of detalleOrden; track dynamic; let i = $index) {
                @if (detalleOrden[i].tipo == 'RADIOGRAFIAS CORPORAL') {
                  <div
                    class="mobile-study-card"
                    >
                    <div class="mobile-study-card__header">
                      <span class="mobile-study-index">Estudio {{ i + 1 }}</span>
                      <span class="mobile-study-type">RX corporal</span>
                    </div>
                    <div class="mobile-study-card__body">
                      <p class="mobile-study-label">Servicio</p>
                      <p class="mobile-study-value">{{ detalleOrden[i].producto }}</p>
                      <p class="mobile-study-label">Observación</p>
                      <textarea
                        class="form-control mobile-observation"
                        name="nombre"
                        readonly
                      >{{detalleOrden[i].pieza}}</textarea>
                      @if (detalleOrden[i].valor != '0') {
                        <div>
                          <p class="mobile-study-label mt-3">Imágenes</p>
                          <div class="mobile-images-grid">
                            @for (f of detalleOrden[i].imagenesSubidas; track f; let j = $index) {
                              <div
                                class="mobile-image-item"
                                >
                                <img [src]="f.imagen" [alt]="'Imagen ' + (j + 1)">
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
              }
            </div>

          </div>





        </div>
      </div>
      <div class="col-md-12">
        <div class="card report-card">
          <h6 class="card-title text-uppercase p-2 text-white mb-1" style="background-color:#2E3D8C">
            Informe general.
          </h6>

          <div class="card-body report-card-body">

            <p class="report-helper-text d-lg-none">
              Redacta o dicta el informe desde tu teléfono y guárdalo cuando termines.
            </p>

            <textarea
              [(ngModel)]="informeHtml"
              class="col-md-12 form-control report-textarea"
              placeholder="Escriba el análisis..."
            ></textarea>

            @if (dictando && textoTemporal) {
              <div class="mt-2 p-2 border rounded text-muted">
                <small>Dictando…</small><br />
                {{ textoTemporal }}
              </div>
            }

            <div class="report-actions">
              <button class="btn btn-info report-action-btn" (click)="startDictation()" [disabled]="dictando">
                🎤 Dictar
              </button>

              <button class="btn btn-danger report-action-btn" (click)="stopDictation()" [disabled]="!dictando">
                ⛔ Detener
              </button>
            </div>

          </div>
        </div>
      </div>

    </div>

    <div class="mobile-bottom-bar d-lg-none">
      <button type="button" class="btn btn-light mobile-bottom-bar__secondary" (click)="volverAtras()">
        Volver
      </button>
      <button type="button" class="btn btn-primary mobile-bottom-bar__primary" (click)="subirImagenes()">
        Guardar informe
      </button>
    </div>
